import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import { orgAPI } from 'services/org'
import { userAPI } from 'services/user'
import { roleAPI } from 'services/role'

import auth from 'api/auth'
import contact from 'api/contact'
import org from 'api/org'
import privateDB from 'api/privatedb'
import user from 'api/user'
import session from 'api/session';
import subscription from 'api/subscription';


const store = configureStore({
  reducer: {


    [orgAPI.reducerPath]: orgAPI.reducer,
    [userAPI.reducerPath]: userAPI.reducer,
    [roleAPI.reducerPath]: roleAPI.reducer,

    auth: auth,
    contact: contact,
    org: org,
    privateDB: privateDB,
    user: user,
    session: session,
    subscription: subscription
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(orgAPI.middleware)
    .concat(userAPI.middleware)
    .concat(roleAPI.middleware)

})

setupListeners(store.dispatch)

export default store;